<template>
  <div class="d-flex vh-100" style="background-color: #f5f7fb;">

    <!-- Menu Lateral Retrátil (Sidebar) -->
    <aside class="sidebar-retatil bg-white border-end d-flex flex-column flex-shrink-0 shadow-sm"
      style="z-index: 1040;">

      <!-- Logo (Se adapta ou centraliza quando encolhido) -->
      <div class="border-bottom d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden"
        style="height: 76px; min-height: 76px;">
        <AppLogo class="sidebar-logo" />
      </div>

      <!-- Navegação -->
      <nav class="nav flex-column py-3 ps-2 pe-0 gap-2 overflow-hidden">

        <router-link to="/dashboard"
          class="nav-link text-secondary rounded-start px-3 py-2 d-flex align-items-center fw-medium text-nowrap"
          exact-active-class="bg-light text-dark">
          <i class="bi bi-house-door fs-5 icon-menu"></i>
          <span class="menu-text ms-3">Início</span>
        </router-link>

        <router-link to="/dashboard/page"
          class="nav-link text-secondary rounded-start px-3 py-2 d-flex align-items-center fw-medium text-nowrap"
          active-class="bg-light text-dark">
          <i class="bi bi-megaphone fs-5 icon-menu"></i>
          <span class="menu-text ms-3">Minhas Campanhas</span>
        </router-link>

        <router-link to="/dashboard/donation-list"
          class="nav-link text-secondary rounded-start px-3 py-2 d-flex align-items-center fw-medium text-nowrap"
          active-class="bg-light text-dark">
          <i class="bi bi-box2-heart-fill fs-5 icon-menu"></i>
          <span class="menu-text ms-3">Doações</span>
        </router-link>
        <router-link to="/dashboard/withdraw-list"
          class="nav-link text-secondary rounded-start px-3 py-2 d-flex align-items-center fw-medium text-nowrap"
          active-class="bg-light text-dark">
          <i class="bi bi-cash-stack fs-5 icon-menu"></i>
          <span class="menu-text ms-3">Saques</span>
        </router-link>

        <!-- <router-link to="/perfil"
          class="nav-link text-secondary rounded-start px-3 py-2 d-flex align-items-center fw-medium text-nowrap"
          active-class="bg-light text-dark">
          <i class="bi bi-person fs-5 icon-menu"></i>
          <span class="menu-text ms-3">Perfil</span>
        </router-link> -->

      </nav>
    </aside>

    <!-- Área de Conteúdo Principal -->
    <div class="flex-grow-1 d-flex flex-column overflow-hidden">

      <!-- Topbar -->
      <header class="bg-white border-bottom px-4 d-flex justify-content-end align-items-center flex-shrink-0"
        style="height: 76px; min-height: 76px;">
        <div class="d-flex align-items-center gap-4">

          <button
            class="btn btn-light rounded-circle text-secondary d-flex align-items-center justify-content-center shadow-sm"
            style="width: 38px; height: 38px;">
            <i class="bi bi-bell"></i>
          </button>

          <div class="dropdown">
            <div class="d-flex align-items-center gap-2 ps-4 border-start" data-bs-toggle="dropdown"
              aria-expanded="false" style="cursor: pointer;">
              <div class="rounded-circle d-flex justify-content-center align-items-center text-white fw-bold shadow-sm"
                style="width: 40px; height: 40px; background-color: #3F0F4E;">
                {{ userInitials }}
              </div>
              <span class="fw-semibold text-dark" style="font-size: 0.95rem;">
                {{ userName }}
              </span>
              <i class="bi bi-caret-down-fill text-primary ms-1" style="font-size: 0.7rem;"></i>
            </div>

            <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-3 p-2"
              style="border-radius: 12px; min-width: 220px;">
              <li>
                <a class="dropdown-item text-danger d-flex align-items-center gap-2 py-2 fw-medium rounded dropdown-hover"
                  href="#" @click.prevent="logout">
                  <i class="bi bi-box-arrow-right fs-5"></i> Sair do Sistema
                </a>
              </li>
            </ul>
          </div>

        </div>
      </header>

      <!-- Páginas Dinâmicas -->
      <main class="flex-grow-1 overflow-auto p-4 p-md-5">
        <router-view />
      </main>

    </div>
  </div>
</template>

<script>
import AppLogo from '@/components/AppLogo.vue'
import api from '@/services/api';

export default {
  name: 'DashboardLayout',
  components: {
    AppLogo
  },
  data() {
    return {
      userName: 'Usuário',
    }
  },
  computed: {
    userInitials() {
      if (!this.userName || this.userName === 'Usuário') return 'U';
      const nameParts = this.userName.trim().split(/\s+/);
      if (nameParts.length === 1) {
        return nameParts[0].substring(0, 2).toUpperCase();
      }

      const firstLetter = nameParts[0][0];
      const lastLetter = nameParts[nameParts.length - 1][0];

      return (firstLetter + lastLetter).toUpperCase();
    }
  },
  mounted() {
    const storedName = localStorage.getItem('name');
    if (storedName) {
      this.userName = storedName;
    }

  },
  methods: {
    async logout() {
      try {
        await api.post('/auth/logout-client');
      } catch (error) {
        console.error('Erro ao encerrar sessão no servidor:', error);
      } finally {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('name');
        localStorage.removeItem('email');
        delete api.defaults.headers.common['Authorization'];
        this.$notify({
          type: 'success',
          title: 'Logout',
          text: 'Sessão encerrada com sucesso.'
        });

        this.$router.push('/login');
      }
    }
  }
}
</script>

<style scoped>
/* =========================
   SIDEBAR RETRÁTIL & LOGO HOVER
========================= */
.sidebar-retatil {
  width: 78px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-x: hidden;
}

.sidebar-retatil:hover {
  width: 260px;
}

/* Quando passar o mouse na sidebar, alteramos a altura da imagem da logo diretamente */
.sidebar-retatil:not(:hover) :deep(.logo-image) {
  height: 28px !important;
}

.sidebar-retatil:hover :deep(.logo-image) {
  height: 70px !important;
  padding-left: 0px;
}

/* Transição suave para a logo */
:deep(.logo-image) {
  transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Visibilidade dos textos do menu */
.sidebar-retatil .menu-text {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  white-space: nowrap;
}

.sidebar-retatil:hover .menu-text {
  opacity: 1;
  visibility: visible;
}

.icon-menu {
  min-width: 32px;
  text-align: center;
}

.nav-link {
  transition: background-color 0.2s ease;
}

.nav-link:hover {
  background-color: #f8f9fa;
  color: #212529 !important;
}

.dropdown-hover:hover {
  background-color: #fff5f5;
  color: #dc3545 !important;
}
</style>